<span class="note">
  <span class="note__msg">Results truncated: limit of {{ limit }} records retrieved.</span>
  <button type="button" class="btn btn--tertiary" (click)="onDetailClicked()">{{ detailText }}</button>
</span>
